import './storeSearchInput.css'

import { Loader, SearchInput, Table } from 'components'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { Name, Percent, Revenue } from 'search/cellComponents'
import { countryIdToString } from 'utils'

import useStoreSearch from './useStoreSearch'

function StoreSearchInput({ initialStoreName, onStoreSelected, requestConfig, selectedCountry, selectedStore }) {
  const { t: translate } = useTranslation()
  const { value, onChange, results, triggerSearch, loading } = useStoreSearch(requestConfig, initialStoreName)
  const [showResults, setShowResults] = useState(false)
  const handleRowClick = store => {
    onChange(store.storeName)
    onStoreSelected(store)
    setShowResults(false)
  }
  const handleCancelSelection = () => {
    onStoreSelected(null)
    onChange('')
  }
  const columns = [
    { key: 'name', title: translate('search.table.shop'), CellRender: Name },
    { key: 'revenue', title: translate('search.table.revenue'), CellRender: Revenue },
    { key: 'percent', title: translate('search.table.percent'), CellRender: Percent },
  ]
  const countryIcon = <div className={`flag flag-${countryIdToString(selectedCountry)}`} />

  useEffect(() => {
    if (results.length > 0) {
      setShowResults(true)
    }
  }, [results])

  return (
    <div className="search-input-with-results">
      <div className="search-input-holder">
        <SearchInput iconLeft={selectedStore && countryIcon} onChange={onChange} onDebounceEnd={triggerSearch} value={value} />
        {selectedStore && (
          <button className="search-close-tap-area" type="button" onClick={handleCancelSelection}>
            <i className="icon close-icon-grey" />
          </button>
        )}
      </div>
      <div>
        {loading && <Loader />}
        {showResults && (
          <div className="overflow-table">
            <Table columns={columns} data={results} onRowClick={handleRowClick} />
          </div>
        )}
      </div>
    </div>
  )
}

StoreSearchInput.propTypes = {
  initialStoreName: PropTypes.string,
  onStoreSelected: PropTypes.func.isRequired,
  requestConfig: PropTypes.object,
  selectedCountry: PropTypes.number,
  selectedStore: PropTypes.number,
}

StoreSearchInput.defaultProps = {
  requestConfig: {},
}

export default StoreSearchInput
